import { MyLensesAssetCategory } from "../../gql-generated/types";

const assetCategoryMap: Record<MyLensesAssetCategory, string> = {
    [MyLensesAssetCategory.ThreeDimensional]: "3D",
    [MyLensesAssetCategory.TwoDimensional]: "2D",
    [MyLensesAssetCategory.Materials]: "Materials",
    [MyLensesAssetCategory.Tools]: "Tools",
    [MyLensesAssetCategory.Vfx]: "Effects",
    [MyLensesAssetCategory.Snapml]: "SnapML",
    [MyLensesAssetCategory.Audio]: "Audio",
    [MyLensesAssetCategory.Reference]: "Reference",
    [MyLensesAssetCategory.Spectacles]: "Specs",
    [MyLensesAssetCategory.CustomComponents]: "Custom Components",
    [MyLensesAssetCategory.Ui]: "UI",
    [MyLensesAssetCategory.ScriptModule]: "Script Modules",
    [MyLensesAssetCategory.Plugin]: "Plugins",
    [MyLensesAssetCategory.Games]: "Games",
};

const isAssetCategory = (key: string): key is MyLensesAssetCategory => {
    return key in assetCategoryMap;
};

export const assetCategoryToDisplayText = (str: string | undefined): string => {
    if (str && isAssetCategory(str)) {
        return assetCategoryMap[str];
    }
    return "";
};
